import { BsExclamationCircle } from 'react-icons/bs';

import styles from './ErrorPage.module.css';

interface Props {
  title?: string;
  message: string;
  showHomepageLink?: boolean;
  onLogout?: () => void;
}

export const ErrorPage = ({ title, message, showHomepageLink, onLogout }: Props) => {
  return (
    <div className={styles.errorPage}>
      <div className={styles.container} role="alert">
        <div className={styles.icon}>
          <BsExclamationCircle />
        </div>
        <div className={styles.content}>
          <h1 className={styles.header}>{title ?? 'Sorry, an error occurred'}</h1>
          <p className={styles.message}>{message}</p>
          {!!showHomepageLink && (
            <a href="/" target="_self" className={styles.link}>
              Go to homepage
            </a>
          )}
          {!!onLogout && (
            <a onClick={onLogout} className={styles.link}>
              Sign out
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
